import { ArrowLeftOutlined } from '@ant-design/icons'
import { useHistory } from 'react-router-dom'
import {
  Button,
  Card,
  Col,
  ContentBody,
  ContentHeader,
  DatePicker,
  Input,
  Row,
  Select,
  Title
} from '../../../core/components'

export const CreateContractPage = () => {
  const { goBack } = useHistory()

  function onOk(value: any) {
    return value
  }

  return (
    <>
      <ContentHeader>
        <Button type="text" onClick={goBack}>
          <ArrowLeftOutlined />
        </Button>
        Novo Contrato
      </ContentHeader>
      <ContentBody>
        <Title>Informações Gerais</Title>
        <Card>
          <Select label="Situação" />
          <DatePicker
            format={'DD/MM/YYYY HH:mm:ss'}
            showTime
            onOk={onOk}
            placeholder="Selecione uma data"
            label="Data Início"
          />
          <DatePicker
            format={'DD/MM/YYYY HH:mm:ss'}
            showTime
            onOk={onOk}
            placeholder="Selecione uma data"
            label="Data Final"
          />
          <Input label="Descrição" />
        </Card>
        <Row gutter={24} style={{ marginTop: 20 }}>
          <Col>
            <Button htmlType="submit" type="primary" style={{ width: 150 }}>
              Cadastrar
            </Button>
          </Col>
          <Col>
            <Button htmlType="reset" type="default">
              Reiniciar
            </Button>
          </Col>
        </Row>
      </ContentBody>
    </>
  )
}
